import Login from "@/views/auth/Login";
import LoginActivation from "@/views/auth/LoginActivation";
import Register from "@/views/auth/Register";
import ADP from "@/views/auth/ADP";
import ResetPassEmail from "@/views/auth/SendEmailPass";
import ResetChangeEmail from "@/views/auth/SendEmailChange";
import ResetPass from "@/views/auth/ResetPass";
import ResetEmail from "@/views/auth/ResetEmail";
export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Iniciar Sesión',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/auth/activation',
    name: 'authActivation',
    component: LoginActivation,
    meta: {
      title: 'Activación de cuenta',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/registro',
    name: 'register',
    component: Register,
    meta: {
      title: 'Registro',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/aviso-de-privacidad',
    name: 'ADP',
    component: ADP,
    meta: {
      title: 'Aviso de Privacidad',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/recuperar-contraseña',
    name: 'ResetPassEmail',
    component: ResetPassEmail,
    meta: {
      title: 'Recuperar Contraseña',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/auth/cambiar-email',
    name: 'ResetChangeEmail',
    component: ResetChangeEmail,
    meta: {
      title: 'Cambiar Correo',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },
  {
    path: '/auth/resetpss',
    name: 'ResetPass',
    component: ResetPass,
    meta: {
      title: 'Recuperar Contraseña',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  },

  {
    path: '/auth/resetemail',
    name: 'ResetEmail',
    component: ResetEmail,
    meta: {
      title: 'Cambiar Email',
      requiresAuth: false,
      requiresObipetsAdmin: false
    },
  }
]
